import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
function AddPurchase() {
    const [ldata, setLdata] = useState(null);
    const [searchKey, setSearchKey] = useState("");
    const [formItems, setFormItems] = useState([]);
    const [storeData, setStoreData] = useState([]); // For storing fetched items
const today = new Date().toISOString().split("T")[0];
// Search ke liye
const [itemSearch, setItemSearch] = useState("");

// Dropdown visible hai ya nahi
const [showItemOptions, setShowItemOptions] = useState(false);

// API se aayega item list
const [items, setItems] = useState([]);

    const [formData, setFormData] = useState({
      medicines: [],
        suppliers: [] ,
        store_purchase_type:'normal',
        store_purchase_id: '',
        store_purchase_no: '',
        store_purchase_date: today,
        store_purchase_mode: '',
        store_invoice_number: '',
        store_invoice_date: today,
        store_purchase_vendor: '',
        store_purchase_total: '',
        store_purchase_gtotal:'',
        store_purchase_return_reason:'',
        store_purchase_dis: '',
        store_purchase_gst: '',
        store_purchase_user: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if ((name + "").localeCompare("search_key") == 0) {
            initData();
        }
    };
const handleChange1 = (e, index) => {
  if (!e || !e.target) return;

  const { name, value } = e.target;
  const name1 = name.replace(/[0-9]/g, "");

  setFormData((prev) => {
    const updatedItems = [...prev.medicines];
    let newValue = value;

    // Qty 1 se niche na jaye
    if (name1 === "store_purchase_item_qty") {
      newValue = Math.max(1, Number(value) || 1);
    }

    updatedItems[index] = {
      ...updatedItems[index],
      [name1]: newValue,
    };

    // 🔹 Single row calculation
    const rate = parseFloat(updatedItems[index].store_purchase_item_rate) || 0;
    const qty = parseFloat(updatedItems[index].store_purchase_item_qty) || 0;
    const disPer = parseFloat(updatedItems[index].store_purchase_item_dis) || 0;
    const gst = parseFloat(updatedItems[index].store_purchase_item_gst) || 0;

    // Row Total (without discount)
    const rowTotal = rate * qty;

    const itemdisPrice = (rate * disPer) / 100 ;
    // Row Discount Amount
    const rowDisAmt = (rowTotal * disPer) / 100;
    
    // Row Final Amount
    const rowFinal = rowTotal - rowDisAmt;
    
    // Row GST Amount
    const rowGstAmt = (rowFinal * gst) / 100;
    
    const itemTotalPrice = rate - itemdisPrice;
    // Row ke fields update karo
    updatedItems[index].store_purchase_item_dis_amt = itemdisPrice.toFixed(2);
    updatedItems[index].store_purchase_item_total = itemTotalPrice.toFixed(2);

    // 🔹 Niche totals row calculation
    let totalAmt = 0;
    let totalDis = 0;
    let grandTotal = 0;
    let totalGst = 0;

    updatedItems.forEach((itm) => {
      const r = parseFloat(itm.store_purchase_item_rate) || 0;
      const q = parseFloat(itm.store_purchase_item_qty) || 0;
      const dP = parseFloat(itm.store_purchase_item_dis) || 0;
      const g = parseFloat(itm.store_purchase_item_gst) || 0;

      const t = r * q;
      const dA = (t * dP) / 100;
      const fA = t - dA;
      const gA = (fA * g) / 100;

      totalAmt += t;
      totalDis += dA;
      grandTotal += fA;
      totalGst += gA;
    });

    return {
      ...prev,
      medicines: updatedItems,
      store_purchase_total: totalAmt.toFixed(2),   // total of qty*rate sabka
      store_purchase_dis: totalDis.toFixed(2),     // total discount sabka
      store_purchase_gtotal: grandTotal.toFixed(2),// final+gst sabka
      store_purchase_gst: totalGst.toFixed(2),     // gst total sabka
    };
  });
};


    const handleSubmit = async (e) => {
        e.preventDefault();
        const fd = new FormData();

        fd.append('store_purchase_id', formData.store_purchase_id);
        fd.append('store_purchase_no', formData.store_purchase_no);
        fd.append('store_purchase_type', formData.store_purchase_type);
        fd.append('store_purchase_date', formData.store_purchase_date);
        fd.append('store_purchase_mode', formData.store_purchase_mode);
        fd.append('store_invoice_number', formData.store_invoice_number);
        fd.append('store_invoice_date', formData.store_invoice_date);
        fd.append('store_purchase_vendor', formData.store_purchase_vendor);
        fd.append('store_purchase_total', formData.store_purchase_total);
        fd.append('store_purchase_dis', formData.store_purchase_dis);
        fd.append('store_purchase_gst', formData.store_purchase_gst);
        fd.append('store_purchase_gtotal', formData.store_purchase_gtotal);
        fd.append('store_purchase_return_reason', formData.store_purchase_return_reason);
        fd.append('store_items', JSON.stringify(formData.medicines) + "");
        fd.append('store_purchase_user', ldata.user_id);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addStorePurchaseUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
                sessionStorage.removeItem("opd_dt")
                window.location.href = "/store_purchase";
            }
            else {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
            }));
        }
    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            var fd = new FormData();
            fd.append('page_no', "0");
            fd.append('search_key', formData.search_key + "");
            fd.append('test_user', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            tests: records
                        }));
                        if (formData.items.length <= 0) {
                            setFormData(prev => ({
                                ...prev,
                                items: records
                            }));
                        }
                    }
                }
            } catch (error) {}

            fd = new FormData();
            fd.append('cat_type', "vital");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            vitals: records
                        }));
                    }
                }
            } catch (error) {}
        }
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('type', "supplier1");
            fd.append('search_key', formData.search_key + "");
            fd.append('page_no', formData.page_no + "");
            fd.append('user_cre_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log("supplier : " + JSON.stringify(response))
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            suppliers: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };

    const handleAddItem = () => {
        const matchedItem = storeData.find(
            (item) => {
    const itemName = item.store_item_name || item.store_settings_short_name || "kkkkk";
    return itemName.toLowerCase().includes(searchKey.toLowerCase());
  }
        );

        if (matchedItem) {
            const newItem = {
                store_purchase_item_name: matchedItem.store_item_name || "",
                store_purchase_item_unit: matchedItem.store_settings_unit_name || "",
                store_purchase_item_gst: matchedItem.store_settings_cgst || "",
            };

            setFormItems((prev) => [...prev, newItem]);
            setFormData(prev => ({
                ...prev,
                medicines: [...prev.medicines, { ...newItem, sn: prev.medicines.length + 1 }]
            }));
            setSearchKey("");
        } else {
            alert("Item not found");
        }
    };

    const getItems = async () => {
  const fd = new FormData();
  fd.append("user_id", ldata?.user_id);

  try {
    const res = await axios.post(
      AppConst.BASE_URL + AppConst.itemListUrl,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    console.log("item list : " + JSON.stringify(res))
    if (res.data.status) {
      setItems(res.data.data || []);
    } else {
      setItems([]);
    }
  } catch (err) {
    console.error("Item fetch error:", err);
    setItems([]);
  }
};


    const initData2 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);

            if (parsed != null && parsed != undefined) {
                const fd = new FormData();
                fd.append('user_id', 1);
                try {
                    const response = await axios.post(AppConst.BASE_URL + AppConst.getStoreByIdUrl, fd, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                    if (response.data.status) {
                        var user_dt = response.data.user_dt;
                        if (user_dt != null && user_dt != undefined && Array.isArray(user_dt.items)) {
                            setStoreData(user_dt.items);
                        }
                    }
                } catch (error) {}
            }
        }
    };

useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
        const parsed = JSON.parse(storedData);
        setLdata(parsed);
        initData();
        initData2();
        getItems();
    }

    // ✅ Generate random number between 100000 - 999999
    const randomNo = Math.floor(100000 + Math.random() * 900000);
    setFormData(prev => ({
        ...prev,
        store_purchase_no: randomNo.toString()
    }));

    if (
        sessionStorage.getItem("opd_dt") != null &&
        sessionStorage.getItem("opd_dt") != undefined &&
        sessionStorage.getItem("opd_dt").length > 0
    ) {
        var tmp = JSON.parse(sessionStorage.getItem("opd_dt") + "");
        if (tmp != null && tmp != undefined) {
            var items = tmp.items;

            setFormData(prev => ({
                ...prev,
                medicines: items,
                store_purchase_id: tmp.store_purchase_id,
                store_purchase_no: tmp.store_purchase_no || prev.store_purchase_no, 
                store_purchase_type: tmp.store_purchase_type,
                store_purchase_date: tmp.store_purchase_date,
                store_purchase_mode: tmp.store_purchase_mode,
                store_invoice_number: tmp.store_invoice_number,
                store_invoice_date: tmp.store_invoice_date,
                store_purchase_vendor: tmp.store_purchase_vendor,
                store_purchase_total: tmp.store_purchase_total,
                store_purchase_dis: tmp.store_purchase_dis,
                store_purchase_gst: tmp.store_purchase_gst,
                store_purchase_gtotal: tmp.store_purchase_gtotal,
                store_purchase_return_reason: tmp.store_purchase_return_reason,
                store_purchase_user: tmp.store_purchase_user,
            }));
        }
    }
}, []);

const handleItemSelect = (item) => {
  setFormData((prev) => ({
    ...prev,
    medicines: [
      ...prev.medicines,
      {
        store_purchase_item_name: item.store_item_name,
        store_purchase_item_unit: item.store_unit,          // ✅ API se aata hai
        store_purchase_item_rate: 0,                        // ✅ rate manually dalna padega ya user input karega
        store_purchase_item_qty: 1,
        store_purchase_item_dis: 0,
        store_purchase_item_dis_amt: 0,
        store_purchase_item_gst: item.store_igst,                         // ✅ agar GST API se nahi aata
        store_purchase_item_total: 0,                       // ✅ initially 0
        store_division: item.store_division,                // extra data (optional)
        store_batch_no: item.store_batch_no,                // extra data (optional)
        store_department: item.store_department,            // extra data (optional)
        store_hsn: item.store_hsn,                          // ✅ useful for GST calculation later
      },
    ],
  }));

  // input clear + dropdown close
  setItemSearch("");
  setShowItemOptions(false);
};






    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>New Purchase</h5>
                                <br />
                                <div class="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div class="row">

                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Purchase No.</label>
                                                    <input name="store_purchase_no" onChange={handleChange} value={formData.store_purchase_no} class="form-control" placeholder="Enter Purchase No." type="text" readOnly style={{background:"#eee"}} />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Purchase Date</label>
                                                    <input name="store_purchase_date" onChange={handleChange} value={formData.store_purchase_date} class="form-control" placeholder="Enter Purchase Date"
                                                        type="date" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Payment Mode</label>
                                                    <select class="form-control"  name="store_purchase_mode" onChange={handleChange} value={formData.store_purchase_mode}>
                                                        <option value="" selected>Select</option>
                                                        <option value="Cash">Cash</option>
                                                        <option value="Online">Online</option>
                                                        <option value="Card">Card</option>

                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Invoice Number</label>
                                                    <input name="store_invoice_number" onChange={handleChange} value={formData.store_invoice_number} class="form-control" placeholder="Enter Invoice Number" type="text" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Invoice Date</label>
                                                    <input name="store_invoice_date" onChange={handleChange} value={formData.store_invoice_date} class="form-control" placeholder="Enter Invoice Date"
                                                        type="date" />
                                                </div>
                                            </div>
                                           <div className="col-md-4">
  <div>
    <label htmlFor="customername-field" className="form-label">Select Supplier</label>
    <select
      className="form-control"
      name="store_purchase_vendor"
      onChange={handleChange}
      value={formData.store_purchase_vendor}
    >
      <option value="">Select</option>
      {formData.suppliers.map((sup, index) => (
        <option key={index} value={sup.user_id}>
          {sup.fname} {sup.lname ? sup.lname : ""}
        </option>
      ))}
    </select>
  </div>
</div>


                                            <div class="row mt-5">
                                                <br />
                                                <div className="col-2"></div>
       <div className="col-xxl-8 col-sm-8">
  <div className="custom-search-box d-flex align-items-center">
    <span className="search-icon-box">
      <i className="ri-barcode-line"></i>
    </span>

    <div style={{ width: "100%" }}>
      <input
        type="text"
        className="form-control custom-search-input"
        placeholder="Item name / Barcode / Itemcode"
        value={itemSearch}
        onFocus={() => setShowItemOptions(true)}
        onChange={(e) => {
          setItemSearch(e.target.value);
          setShowItemOptions(true);
        }}
      />

      {/* Searchable dropdown */}
      {showItemOptions && (
        <div className="dropdown-menu show w-100">
          {items
            ?.filter(
              (i) =>
                i.store_item_name.toLowerCase().includes(itemSearch.toLowerCase()) ||
                i.store_item_code?.toLowerCase().includes(itemSearch.toLowerCase())
            )
            .map((i, index) => (
              <div
                key={index}
                className="dropdown-item"
                onClick={() => handleItemSelect(i)}
              >
                {i.store_hsn} - {i.store_item_name} ({i.store_unit})
              </div>
            ))}
        </div>
      )}
    </div>
  </div>
</div>
 <div className="col-2"></div>

                                                <br/>
                                                <div class="row my-3">
                                                    <div class="col-lg-8">
                                                        <h4>Items</h4>
                                                    </div>
                                                    {/* <div class="col-lg-4" style={{ textAlign: "right" }}>
                                                        <button type="button"
                                                         onClick={(e) => {
                                                            e.preventDefault();
                                                            var tmp = formData.medicines;
                                                            tmp.push({
                                                                sn: (tmp.length + 1),
                                                                store_purchase_item_name: '',
                                                                store_purchase_item_unit: '',
                                                                store_purchase_item_rate: '',
                                                                store_purchase_item_qty: '',
                                                                store_purchase_item_dis: '',
                                                                store_purchase_item_dis_amt: '',
                                                                store_purchase_item_gst: '',
                                                                store_purchase_item_total: '',
                                                            });

                                                            setFormData(prev => ({
                                                                ...prev,
                                                                medicines: tmp
                                                            }));

                                                        }}
                                                        class="btn btn-primary">Add</button>
                                                    </div> */}
                                                </div>
                                                <br />
                                            </div>
                                            <div class="col-md-12">
                                                <div class="card-body pt-0">
                                                    <div>

                                                        <div class="table-responsive table-card mb-1 p-2">
                                                            <table class="table table-nowrap align-middle" id="orderTable">
                                                                <thead class="text-muted table-light" >
                                                                    <tr class="text-uppercase">

                                                                        <th data-sort="customer_name">Sr. No.</th>
                                                                        <th data-sort="customer_name">Item Name</th>
                                                                        <th data-sort="customer_name">Unit</th>
                                                                        <th data-sort="customer_name">Rate</th>
                                                                        <th data-sort="customer_name">QTY</th>
                                                                        <th data-sort="customer_name">Dis %</th>
                                                                        <th data-sort="customer_name">Dis Amount</th>
                                                                        <th data-sort="customer_name">Gst</th>
                                                                        <th data-sort="customer_name">Total</th>
                                                                    </tr>
                                                                </thead>
                                                             <tbody className="list form-check-all">
  {formData.medicines.length > 0 ? (
    formData.medicines.map((item, index) => (
      <tr key={index}>
        <td className="customer_name">{index + 1}.</td>
        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name={`store_purchase_item_name${index}`}
            value={item.store_purchase_item_name}
            onChange={(e) => handleChange1(e, index)}
            readOnly style={{background: "#EEE"}}
          />
        </td>
        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name={`store_purchase_item_unit${index}`}
            value={item.store_purchase_item_unit}
            onChange={(e) => handleChange1(e, index)}
             readOnly style={{background: "#EEE"}}
          />
        </td>
        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name={`store_purchase_item_rate${index}`}
            value={item.store_purchase_item_rate}
            onChange={(e) => handleChange1(e, index)}
          />
        </td>
       <td className="customer_name">
  <input
    type="number"
    className="form-control"
    name={`store_purchase_item_qty${index}`}
    value={item.store_purchase_item_qty}
    min={1}   
    onChange={(e) => handleChange1(e, index)}
  />
</td>

        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name={`store_purchase_item_dis${index}`}
            value={item.store_purchase_item_dis}
            onChange={(e) => handleChange1(e, index)}
          />
        </td>
        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name={`store_purchase_item_dis_amt${index}`}
            value={item.store_purchase_item_dis_amt}
            onChange={(e) => handleChange1(e, index)}
            readOnly style={{background: "#EEE"}}
          />
        </td>
        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name={`store_purchase_item_gst${index}`}
            value={item.store_purchase_item_gst}
            onChange={(e) => handleChange1(e, index)}
            readOnly style={{background: "#EEE"}}
          />
        </td>
        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name={`store_purchase_item_total${index}`}
            value={item.store_purchase_item_total}
            onChange={(e) => handleChange1(e, index)}
          />
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" className="text-center text-muted">
        No items selected yet
      </td>
    </tr>
  )}

  {/* Totals row */}
  {formData.medicines.length > 0 && (
    <>
      <tr>
        <td className="customer_name" colSpan="5"></td>
        <td className="customer_name"><strong>Total</strong></td>
        <td className="customer_name"><strong>Discount</strong></td>
        <td className="customer_name"><strong>Final Amount</strong></td>
        <td className="customer_name"><strong>Gst Amount</strong></td>
      </tr>
      <tr>
        <td className="customer_name" colSpan="5"></td>
        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name="store_purchase_total"
            value={formData.store_purchase_total}
            onChange={handleChange}
          />
        </td>
        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name="store_purchase_dis"
            value={formData.store_purchase_dis}
            onChange={handleChange}
          />
        </td>
        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name="store_purchase_gtotal"
            value={formData.store_purchase_gtotal}
            onChange={handleChange}
          />
        </td>
        <td className="customer_name">
          <input
            type="text"
            className="form-control"
            name="store_purchase_gst"
            value={formData.store_purchase_gst}
            onChange={handleChange}
          />
        </td>
      </tr>
    </>
  )}
</tbody>


                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddPurchase;
